import React, { useState } from "react";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from "@atlaskit/modal-dialog";
import Button from "@atlaskit/button/new";
import { useDispatch, useSelector } from "react-redux";
import { selectFlow, setEditorSaved } from "../../../../redux/actions/integrationActions";
import OrderActionList from "./OrderActionList";
import ChildWorkItemsIcon from "@atlaskit/icon/core/child-work-items";
const OrderActionButton = () => {
  const dispatch = useDispatch();
  const flow = useSelector((state) => state.integration.flow);
  const [isOpen, setOpen] = useState(false);
  const [draftActions, setDraftActions] = useState([]);

  const onOpen = () => {
    setDraftActions(Array.isArray(flow?.actions) ? flow.actions : []);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setDraftActions([]);
  };

  const onSave = () => {
    const currentActions = Array.isArray(flow?.actions) ? flow.actions : [];
    const hasChanged = JSON.stringify(currentActions) !== JSON.stringify(draftActions);

    if (hasChanged) {
      dispatch(
        selectFlow({
          ...flow,
          actions: draftActions,
        }),
      );
      dispatch(setEditorSaved(false));
    }

    onClose();
  };

  return (
    <>
      <div className="ihub-sidebar-action-widget-add-action ihub-order-action-button" onClick={onOpen}>
        <span className="ihub-sidebar-action-widget-add-action-text">
          <ChildWorkItemsIcon />
          Order
        </span>
      </div>
      <ModalTransition>
        {isOpen && (
          <Modal onClose={onClose} width="x-large">
            <ModalHeader>
              <ModalTitle>Order Actions</ModalTitle>
            </ModalHeader>
            <ModalBody>
              <OrderActionList actions={draftActions} onChange={setDraftActions} />
            </ModalBody>
            <ModalFooter>
              <Button appearance="subtle" onClick={onClose}>
                Cancel
              </Button>
              <Button appearance="primary" onClick={onSave}>
                Save
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};

export default OrderActionButton;
